// extracted by mini-css-extract-plugin
export default {"watchButton":"GLinkButton_watchButton__h8L4-"};